import { render, staticRenderFns } from "./user-reviews.vue?vue&type=template&id=4590612e"
import script from "./user-reviews.vue?vue&type=script&lang=ts"
export * from "./user-reviews.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports